module.exports = __webpack_public_path__ + "img/curv_17_a.34bbc8cf.jpg";